import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedAppModule } from '../app.module.shared';
import { EmailTemplatesRoutingModule } from './email.templates.routing.module'
import { EmailTemplatesListComponent } from './email.templates.list/email.templates.list.component'

@NgModule({
  imports: [
    CommonModule,
    SharedAppModule,
    EmailTemplatesRoutingModule
  ],
  declarations: [
    EmailTemplatesListComponent
  ]
})
export class EmailTemplatesModule { }
